/** Parses an unknown error into an Error object. */
export function parseError(error: unknown): Error {
  // Empty error.
  if (!error) {
    // biome-ignore lint/suspicious/useErrorMessage: No error message can be derived.
    return new Error();
  }

  // Already defined error.
  if (error instanceof Error) {
    return error;
  }

  // A string error.
  if (typeof error === 'string') {
    return new Error(error);
  }

  // For other values, initialize a return value.
  let errorString: string | undefined;

  // An object of shape { message: ... }.
  if (typeof error === 'object') {
    const errorObject = error as Record<string, unknown>;

    if (errorObject.message) {
      errorString = String(errorObject.message);
    } else {
      errorString = JSON.stringify(errorObject);
    }
  } else {
    errorString = String(error);
  }

  if (errorString.length > 100) {
    errorString = `${errorString.substring(0, 100)}...`;
  }

  return new Error(errorString);
}
